import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import Loc from "../../services/localization";
import CONFIG_COMPANY from "../../services/myConfig";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            id: 0,
            userId: 0,
            name: '',
            locale: LocService,
            role: '',
            isLoading: true,
            items: [],
            chartWidth: 720,
            chartHeight: 120,
            padX: 16,             // unutrašnji horizontalni padding u koordinatama SVG-a
            padY: 10,
            groups: []
        }
    },
    methods: {
        load: load,
        getDateDisplay: getDateDisplay,
        detectMeasure(arr) {
            return arr.some(r => r.measure === 'KG') ? 'KG' : 'REP';
        },
        valueOf(r) {
            return r.measure === 'KG' ? Number(r.weight) : Number(r.quantity);
        },
        labelForMeasure(m) {
            if (m === 'KG') return 'KG';
            if (m === 'REP') return 'REP';
            if (m === 'IMAGE') return 'Slike';
            return 'Mera';
        },
        fmtValue(v, m) {
            if (v == null) return '-';
            return m === 'KG' ? `${v} kg` : `${v}`;
        },
        dateKey(createdTime) {
            const secs = Math.floor(Number(createdTime));
            const d = new Date(secs * 1000);
            return d.toISOString().split('T')[0];
        },
        humanDate(key) {
            const d = new Date(key);
            return d.toLocaleDateString();
        },
        shortDate(d) {
            return d.toLocaleDateString(undefined, {day: '2-digit', month: '2-digit'});
        },
        xPos(i, n) {
            if (n <= 1) return this.chartWidth / 2;
            const innerW = Math.max(50, this.chartWidth - 2 * this.padX);
            const step = innerW / (n - 1);
            return this.padX + i * step;
        },
        yPos(val, min, max) {
            if (max === min) return this.chartHeight / 2;
            const p = (val - min) / (max - min);
            const innerH = Math.max(20, this.chartHeight - 2 * this.padY);
            // veće vrednosti da idu gore:
            return this.chartHeight - (this.padY + p * innerH);
        },
        // xPos(i, n) {
        //     return n <= 1 ? this.chartWidth / 2 : i * (this.chartWidth / (n - 1));
        // },
        // yPos(val, min, max) {
        //     if (max === min) return this.chartHeight / 2;
        //     const p = (val - min) / (max - min);
        //     return this.chartHeight - p * this.chartHeight;
        // },
        polyPoints(group) {
            return group.points.map((pt, i) => `${this.xPos(i, group.points.length)},${this.yPos(pt.value, group.min, group.max)}`).join(' ');
        },
        abs(n) {
            return Math.abs(n);
        },
        groupsMap() {
            if (!this.items || !this.items.length) return [];
            const byId = new Map();
            for (const it of this.items) {
                if (!it || !it.trainingName) continue;
                if (!byId.has(it.trainingName)) byId.set(it.trainingName, []);
                byId.get(it.trainingName).push(it);
            }


            const out = [];
            byId.forEach((arr, id) => {
                const allImage = arr.every(r => r.measure === 'IMAGE');
                if (allImage) {
                    const imagesByDate = {};
                    arr.forEach(r => {
                        const d = this.dateKey(r.trainingTime);
                        if (!imagesByDate[d]) imagesByDate[d] = [];
                        if (r.userImage) imagesByDate[d].push(r.userImage);
                    });
                    out.push({id, measure: 'IMAGE', imagesByDate});
                    return;
                }


                const measure = this.detectMeasure(arr);
                const daily = new Map();
                arr.forEach(r => {
                    const d = this.dateKey(r.trainingTime);
                    const v = this.valueOf(r);
                    if (v == null) return;
                    if (!daily.has(d) || v > daily.get(d)) daily.set(d, v);
                });


                const points = Array.from(daily.entries())
                    .map(([d, value]) => ({date: new Date(d), dateLabel: this.humanDate(d), value}))
                    .sort((a, b) => a.date - b.date);


                if (!points.length) return;
                const values = points.map(p => p.value);
                const min = Math.min(...values);
                const max = Math.max(...values);
                const last = points[points.length - 1];
                const best = points.reduce((m, p) => (!m || p.value > m.value ? p : m), null);
                const first = points[0];
                const trend = first && first.value ? Math.round(((last.value - first.value) / Math.max(1, first.value)) * 100) : 0;


                out.push({id, measure, points, min, max, best, last, trend});
            });


            return out.sort((a, b) => a.id - b.id);
        },
        _measureWidth() {
            // uzmi širinu prve .progress-right (dovoljno je ista za sve redove)
            const el = this.$el && this.$el.querySelector('.progress-row .progress-right');
            if (!el) return;
            const w = Math.floor(el.getBoundingClientRect().width);
            if (w && Math.abs(w - this.chartWidth) > 2) this.chartWidth = w;
        },
    },



    beforeMount() {
        this.id = this.$route.query.id;
        this.userId = this.$route.query.userId;
        this.name = this.$route.query.name;
        this.load()
    },
    mounted() {
        this.$nextTick(() => {
            this._measureWidth();
            window.addEventListener('resize', this._measureWidth);
        });
    },
    created() {
        let _self = this;
        setTimeout(function () {
            _self._measureWidth();
        }, 500)

    },
    beforeDestroy() {
        window.removeEventListener('resize', this._measureWidth);
    },
}


function load() {
    let _self = this;
    AdminApiService.getPersonalProgramsResults(this.id, this.userId)
        .then((response) => {
            _self.items = response.data;
            _self.groups = _self.groupsMap()
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getDateDisplay(item) {
    let fromDate = this.$moment(item.startTime * 1000).format('DD-MM-YYYY');
    let toDate = this.$moment(item.endTime * 1000).format('DD-MM-YYYY');
    return fromDate + " - " + toDate;
}



// WEBPACK FOOTER //
// ./src/components/Personal/PersonalProgramResults.js